/**
 * SKE-4681 — the pinned sidebar entry.
 *
 * PINNED MEANS THE NON-SCROLLING DIV. The sidebar has a small fixed block
 * holding only Home, and then a scrolling container holding everything else.
 * This belongs beside Home. Anywhere inside the scrolling container and it
 * scrolls away, which is the opposite of what pinned was asked for.
 *
 * Position constant, volume rising. The label escalates with the register —
 * "Update Instagram" through weeks 1 and 2, "Action required" with
 * the red treatment in week 3 — so weeks 1 and 2 stay calm while the entry
 * never moves.
 *
 * Renders nothing at all unless the campaign is on and this customer has
 * accounts still to update.
 */

import React from "react";

import { INSTAGRAM_CAMPAIGN_ROUTE, registerFor } from "./campaign-registers";
import { useCampaignStatus } from "./use-campaign-status";

export interface InstagramCampaignMenuEntryProps {
  /**
   * The sidebar's own menu-item component, injected rather than imported.
   * `menu.tsx` owns the active-state, tooltip and collapsed-rail behaviour, and
   * a second copy of that here would drift from it.
   */
  render: (entry: {
    to: string;
    label: string;
    isUrgent: boolean;
  }) => React.ReactElement;
}

export function InstagramCampaignMenuEntry({
  render,
}: InstagramCampaignMenuEntryProps): React.ReactElement | null {
  const { status, isAffected } = useCampaignStatus();

  if (!isAffected) return null;

  const register = registerFor(status?.campaign?.week);

  return render({
    to: INSTAGRAM_CAMPAIGN_ROUTE,
    label: register.menuLabel,
    isUrgent: register.menuIsUrgent,
  });
}
